import "../form/behavior.js";

class SubmissionFormBehavior extends Sparkle.PageBuilder.Components.FormAbstractBehavior {}
SubmissionFormBehavior.register("submission_form");
